export function filterInactiveGifts(gifts) {
  const filtered = [];
  const inactive = [];
  (gifts || []).forEach((gift) => {
    if (gift.status === "expired") inactive.push(gift);
    else filtered.push(gift);
  });
  return [filtered, inactive];
}

export function determineHideAllEditButtons(array = []) {
  let allHidden = true;
  array.forEach((gift) => {
    if (gift.userCanEdit) allHidden = false;
  });
  return allHidden;
}

export function formatDateString(dateString, options) {
  if (!dateString) return "N/A";
  const date = new Date(dateString.replace(/-/g, "/").replace(/T.+/, ""));
  const month = date.toLocaleString("en-us", { month: "short" });
  const year = date.getFullYear();
  const day = date.getDate();

  if (options?.includeYear) {
    return `${month} ${day}, ${year}`;
  } else {
    return `${month} ${day}`;
  }
}
